/**
 * 派生 Chat Tab「更多」菜单每项展示态，与 ChatContent 内 onTabMoreBookmark /
 * onTabMoreShare / handleTabMoreRename / handleHistoryClick / onReNewChatClick
 * 的 guard 及 optionMenus 对齐；History 在移动端仍可见（与工具条分叉）。
 */

type ChatTabMoreMenuItemUi = {
  visible?: boolean;
  disabled?: boolean;
  icon?: string;
  iconClassName?: string;
};

export type ChatTabMoreMenuItemUiStateMap = Partial<
  Record<
    "bookmark" | "share" | "rename" | "history" | "new-chat",
    ChatTabMoreMenuItemUi
  >
>;

export type GetChatTabMoreMenuItemUiStateParams = {
  messageCount: number;
  isLoading: boolean;
  isStarLoading: boolean;
  chatId: string | null | undefined;
  isMarked: boolean;
};

export function getChatTabMoreMenuItemUiState(
  params: GetChatTabMoreMenuItemUiStateParams,
): ChatTabMoreMenuItemUiStateMap {
  const { messageCount, isLoading, isStarLoading, chatId, isMarked } = params;
  const hasMessages = messageCount > 0;
  const isDisable = isLoading || !hasMessages;
  const shareBookmarkDisabled = isStarLoading || isDisable;
  const renameDisabled = !chatId || isStarLoading;

  const shareIconClass = shareBookmarkDisabled
    ? "text-content_tertiary"
    : "text-content_primary";

  const bookmarkIconClass = isMarked
    ? "text-content_accent4_primary"
    : shareBookmarkDisabled
      ? "text-content_tertiary"
      : "text-content_primary";

  return {
    share: {
      visible: true,
      disabled: shareBookmarkDisabled,
      iconClassName: shareIconClass,
    },
    bookmark: {
      visible: true,
      disabled: shareBookmarkDisabled,
      icon: isMarked ? "start-fill" : "star",
      iconClassName: bookmarkIconClass,
    },
    rename: {
      visible: true,
      disabled: renameDisabled,
      iconClassName: renameDisabled
        ? "text-content_tertiary"
        : "text-content_primary",
    },
    history: {
      visible: true,
      disabled: false,
      iconClassName: "text-content_primary",
    },
    "new-chat": {
      visible: true,
      disabled: !hasMessages,
      iconClassName: !hasMessages
        ? "text-content_tertiary"
        : "text-content_primary",
    },
  };
}
